import Swiper from '../vendors/swiper.min';
import debounce from './debounce';

function updateCarouselPosition(oc, pg) {
  let position = 0;
  if(window.innerWidth >= 1024) {
    position = pg.position().top;
  }

  oc.css({ marginTop: position });
}

export default function offTopicCarousel () {
    const oc = $('.offer-carousel');
    const pg = $('.js-products-pargraph');
    const oc_options = {
        loop: true,
        speed: 600,
        autoHeight: true,
        pagination: {
            el: '.offer-pagination',
            type: 'bullets',
            clickable: 'true'
        },
        autoplay: {
            delay: 6000,
            disableOnInteraction: false
        }
    };

    if (oc.length) {
        const offer_carousel = new Swiper(oc, oc_options);

        if (pg.length) {
          window.addEventListener('resize', debounce(() => updateCarouselPosition(oc, pg), 200, false), { passive: true });
          updateCarouselPosition(oc, pg);
        }
    }
}



// WEBPACK FOOTER //
// ./front/bankomania/js/modules/offer_carousel.js